<template>
  <div class="flex layout-column pa-1" style="overflow-y: auto;">
    <div>
      <lx-expansion-panels :single-open="false" v-model="panel">

        <!--   Melder  (panel 0)   -->

        <lx-expansion-panel :disabled="true" :isInvalid="openInvalidModule(0, 'report_header')">
          <lx-expansion-panel-header :disabled="true"
                                     icon="mdi-account-edit"
                                     :main-headline="$t('FORMS_DIVERSE.REPORTER_HEADER')"
                                     :sub-headline="$t('FORMS_DIVERSE.REPORTER_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="report_header">
              <div class="pa-4 layout-column">
                <melder path="report_header"
                        :isDisabled="isFormDisabled()"
                        :validationRef="validationRef"
                        :isMedicalCommunity="isMedicalCommunity"
                        v-model="model.report_header"
                        :additionalItemsList="additionalItemsList"
                        form-key="register"
                        class="layout-row layout-wrap flex-gt-sm-100 flex-100"></melder>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Diagnose   (panel 1)  -->

        <lx-expansion-panel :disabled="true" :isInvalid="openInvalidModule(1, 'diagnose')">
          <lx-expansion-panel-header :disabled="true"
                                     icon="mdi-heart-pulse"
                                     :main-headline="$t('FORMS_DIVERSE.MODULE_DIAGNOSIS_HEADER') + ' *'"
                                     :sub-headline="$t('COMPONENT_PATIENT.DIAGNOSE_HEADER_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="diagnose">
              <div class="pa-4 layout-row layout-wrap">
                <diagnose path="diagnose"
                          :isDisabled="isFormDisabled()"
                          :validationRef="validationRef"
                          :multiFormsCount="multiFormsCount"
                          v-model="model.diagnose"
                          :classifications="model.weitere_klassifikation"
                          :subjId="model.subj_id"
                          :formId="formId"
                          :patientId="patientId"
                          class="layout-row layout-wrap flex-gt-sm-100 flex-100"></diagnose>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Modul Malignes Melanom bei Diagnose C43* (panel 2) -->

        <lx-expansion-panel :disabled="true"
                            :isInvalid="openInvalidModule(2, 'modul_malignes_melanom')"
                            v-show="showModuleInDependencyToICD10('malignes', model.patient_id)">
          <lx-expansion-panel-header :disabled="true"
                                     icon="mdi-hexagon-multiple"
                                     :main-headline="$t('FORMS_DIVERSE.MODULE_MALIGNES_MELANOM_HEADER')"
                                     :sub-headline="$t('FORMS_DIVERSE.MODULE_MALIGNES_MELANOM_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="modul_malignes_melanom">
              <div class="pa-4 layout-row layout-wrap">
                <malignes-melanom path="modul_malignes_melanom"
                                  :base="model.diagnose"
                                  :tnm="model.ptnm"
                                  :validationRef="validationRef"
                                  formKey="register"
                                  :isDisabled="isFormDisabled()"
                                  v-model="model.modul_malignes_melanom"
                                  class="layout-row layout-wrap flex-gt-sm-100 flex-100"></malignes-melanom>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Modul Prostata bei Diagnosen C61 und D07.5 (panel 3) -->

        <lx-expansion-panel :disabled="true"
                            :isInvalid="openInvalidModule(3, 'modul_prostata')"
                            v-show="showModuleInDependencyToICD10('prostata', model.patient_id)">
          <lx-expansion-panel-header :disabled="true"
                                     icon="mdi-human-male"
                                     :main-headline="$t('FORMS_DIVERSE.MODULE_PROSTATA_HEADER')"
                                     :sub-headline="$t('FORMS_DIVERSE.MODULE_PROSTATA_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="modul_prostata">
              <div class="pa-4 layout-row layout-wrap">
                <modul-prostata path="modul_prostata"
                                :base="model.diagnose"
                                formKey="register"
                                :patientId="patientId"
                                :validationRef="validationRef"
                                :isDisabled="isFormDisabled()"
                                v-model="model.modul_prostata"
                                class="layout-row layout-wrap flex-gt-sm-100 flex-100"></modul-prostata>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Modul Mamma bei Diagnosen C50 und D05 (panel 4) -->

        <lx-expansion-panel :disabled="true"
                            :isInvalid="openInvalidModule(4, 'modul_mamma')"
                            v-show="showModuleInDependencyToICD10('mamma', model.patient_id)">
          <lx-expansion-panel-header :disabled="true"
                                     icon="mdi-human-female"
                                     :main-headline="$t('FORMS_DIVERSE.MODULE_MAMMA_HEADER')"
                                     :sub-headline="$t('FORMS_DIVERSE.MODULE_MAMMA_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="modul_mamma">
              <div class="pa-4 layout-row layout-wrap">
                <modul-mamma path="modul_mamma"
                             :base="model.diagnose"
                             formKey="register"
                             :validationRef="validationRef"
                             :isDisabled="isFormDisabled()"
                             v-model="model.modul_mamma"
                             class="layout-row layout-wrap flex-gt-sm-100 flex-100"></modul-mamma>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Modul Kolo bei Diagnosen C18, C19, C20, D01.0, D01.1, D01.2  (panel 5)-->

        <lx-expansion-panel :disabled="true"
                            :isInvalid="openInvalidModule(5, 'modul_darm')"
                            v-show="showModuleInDependencyToICD10('kolo', model.patient_id)">
          <lx-expansion-panel-header :disabled="true"
                                     icon="mdi-emoticon-poop"
                                     :main-headline="$t('FORMS_DIVERSE.MODULE_KOLO_HEADER')"
                                     :sub-headline="$t('FORMS_DIVERSE.MODULE_KOLO_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="modul_darm">
              <div class="pa-4 layout-row layout-wrap">
                <modul-kolo path="modul_darm"
                            :base="model.diagnose"
                            formKey="register"
                            :validationRef="validationRef"
                            :isDisabled="isFormDisabled()"
                            v-model="model.modul_darm"
                            class="layout-row layout-wrap flex-gt-sm-100 flex-100"></modul-kolo>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Leistungszustand   (panel 6)  -->

        <lx-expansion-panel :disabled="true" :isInvalid="openInvalidModule(6, 'allgemeiner_leistungszustand')">
          <lx-expansion-panel-header :disabled="true"
                                     :main-headline="$t('FORMS_DIVERSE.GENERAL_PERFORMANCE_STATE') + ' *'"
                                     icon="mdi-arm-flex"
                                     :sub-headline="$t('FORMS_DIVERSE.GENERAL_PERFORMANCE_STATE_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="allgemeiner_leistungszustand">
              <div class="px-4 pt-4 layout-row layout-wrap">
                <leistungszustand path="allgemeiner_leistungszustand"
                                  :isDisabled="isFormDisabled()"
                                  v-model="model.allgemeiner_leistungszustand"
                                  class="layout-row layout-wrap flex-gt-sm-100 flex-100"></leistungszustand>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Histologie   (panel 7)  -->

        <lx-expansion-panel :isInvalid="model && model.histologie && model.histologie.length > 1 || openInvalidModule(7, 'histologie')">
          <lx-expansion-panel-header :main-headline="$t('FORMS_DIVERSE.HISTOLOGY_HEADER')"
                                     icon="mdi-stethoscope"
                                     :isValid="model && (model.histologie && model.histologie.length < 2) || !model.histologie"
                                     :sub-headline="$t('FORMS_DIVERSE.HISTOLOGY_SINGLE_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="histologie">
              <histologie path="histologie"
                          :isDisabled="isFormDisabled()"
                          :validationRef="validationRef"
                          v-model="model.histologie"
                          :deleteSelectedItem="deleteItem"
                          :diagnosis="leadDiagnosisCode"
                          :leadDate="leadDate"
                          :patientId="patientId"
                          :formStatus="formStatus"
                          class="layout-row layout-wrap flex-gt-sm-100 flex-100"></histologie>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   cTNM    (panel 8) -->

        <lx-expansion-panel :disabled="true"
                            :isInvalid="openInvalidModule(8, 'ctnm')">
          <lx-expansion-panel-header :disabled="true"
                                     main-headline="Prätherapeutisches TNM (cTNM)"
                                     icon="mdi-hexagon-multiple-outline"
                                     :sub-headline="$t('FORMS_DIVERSE.TNM_HEADER_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="ctnm">
              <div class="pa-4 layout-row layout-wrap">
                <tnm path="ctnm"
                     :validationRef="validationRef"
                     :isDisabled="isFormDisabled()"
                     v-model="model.ctnm"
                     :patientId="patientId"
                     :diagCode="leadDiagnosisCode"
                     :diagDate="leadDate"
                     class="layout-row layout-wrap flex-gt-sm-100 flex-100"></tnm>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   pTNM    (panel 9) -->

        <lx-expansion-panel :isInvalid="openInvalidModule(9, 'ptnm')">
          <lx-expansion-panel-header main-headline="Postoperatives TNM (pTNM)"
                                     icon="mdi-hexagon-multiple-outline"
                                     :sub-headline="$t('FORMS_DIVERSE.TNM_HEADER_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="ptnm">
              <div class="pa-4 layout-row layout-wrap">
                <tnm path="ptnm"
                     :validationRef="validationRef"
                     :isDisabled="isFormDisabled()"
                     v-model="model.ptnm"
                     :patientId="patientId"
                     :diagCode="leadDiagnosisCode"
                     :diagDate="leadDate"
                     class="layout-row layout-wrap flex-gt-sm-100 flex-100"></tnm>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Weitere Klassifikationen  (panel 10)  -->

        <lx-expansion-panel :isInvalid="openInvalidModule(10, 'weitere_klassifikation')">
          <lx-expansion-panel-header :main-headline="$t('FORMS_DIVERSE.FURTHER_CLASSIFICATION_HEADER')"
                                     icon="mdi-vector-polyline"
                                     :sub-headline="$t('FORMS_DIVERSE.FURTHER_CLASSIFICATION_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="weitere_klassifikation">
              <weitere-klassifikationen path="weitere_klassifikation"
                                        :isDisabled="isFormDisabled()"
                                        :validationRef="validationRef"
                                        v-model="model.weitere_klassifikation"
                                        v-bind="{addItem, deleteItem}"
                                        :patientId="patientId"
                                        class="layout-wrap flex-gt-sm-100 flex-100"></weitere-klassifikationen>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Frühere Tumorerkrankung   (panel 11)  -->

        <lx-expansion-panel :isInvalid="openInvalidModule(11, 'fruehere_tumorerkrankung')">
          <lx-expansion-panel-header :main-headline="$t('FORMS_DIVERSE.PRE_EXISTING_ILLNESS_HEADER')"
                                     icon="mdi-virus"
                                     :sub-headline="$t('FORMS_DIVERSE.PRE_EXISTING_ILLNESS_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="fruehere_tumorerkrankung">
              <fruehere-tumorerkrankung path="fruehere_tumorerkrankung"
                                        :isDisabled="isFormDisabled()"
                                        :validationRef="validationRef"
                                        v-model="model.fruehere_tumorerkrankung"
                                        :addNewItem="addItem"
                                        :deleteSelectedItem="deleteItem"
                                        :leadDate="leadDate"
                                        :patientId="patientId"
                                        class="layout-wrap flex-gt-sm-100 flex-100"></fruehere-tumorerkrankung>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Fernmetastase   (panel 12)  -->

        <lx-expansion-panel :isInvalid="openInvalidModule(12, 'fernmetastase')">
          <lx-expansion-panel-header :main-headline="$t('FORMS_DIVERSE.DISTANT_METASTASES_HEADER')"
                                     icon="mdi-chart-bubble"
                                     :sub-headline="$t('FORMS_DIVERSE.DISTANT_METASTASES_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="fernmetastase">
              <fernmetastase path="fernmetastase"
                             :isDisabled="isFormDisabled()"
                             v-model="model.fernmetastase"
                             :validationRef="validationRef"
                             :patientId="patientId"
                             v-bind="{addItem, deleteItem, leadDate}"
                             class="layout-wrap flex-gt-sm-100 flex-100"></fernmetastase>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Genetische Varianten   (panel 13)  -->

        <lx-expansion-panel :isInvalid="openInvalidModule(13, 'genetische_varianten')">
          <lx-expansion-panel-header :main-headline="$t('FORMS_DIVERSE.GENETIC_VARIANT_HEADER')"
                                     icon="mdi-dna"
                                     :sub-headline="$t('FORMS_DIVERSE.GENETIC_VARIANT_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="genetische_varianten">
              <genetische-variante path="genetische_varianten"
                                   :isDisabled="isFormDisabled()"
                                   v-model="model.genetische_varianten"
                                   :validationRef="validationRef"
                                   :patientId="patientId"
                                   :addNewItem="addItem"
                                   :deleteSelectedItem="deleteItem"
                                   class="layout-wrap flex-gt-sm-100 flex-100"></genetische-variante>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Modul Allgemein  (panel 14)  -->

        <lx-expansion-panel>
          <lx-expansion-panel-header :main-headline="$t('FORMS_DIVERSE.MODULE_COMMON_HEADER')"
                                     icon="mdi-phone-classic"
                                     :sub-headline="$t('FORMS_DIVERSE.MODULE_COMMON_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <div class="px-4 pt-4 layout-row layout-wrap">
              <modul-allgemein path="modul_allgemein"
                               :isDisabled="isFormDisabled()"
                               :validationRef="validationRef"
                               v-model="model.modul_allgemein"
                               class="layout-wrap flex-gt-sm-100 flex-100"></modul-allgemein>
            </div>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Anmerkung   (panel 15) -->

        <lx-expansion-panel :isInvalid="openInvalidModule(15, 'anmerkung')">
          <lx-expansion-panel-header :main-headline="$t('FORMS_DIVERSE.ANNOTATION_HEADER')"
                                     :sub-headline="$t('FORMS_DIVERSE.ANNOTATION_SUB_LINE')"
                                     icon="mdi-lead-pencil">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="anmerkung">
              <div class="px-4 pt-4 layout-row layout-wrap">
                <anmerkung path="anmerkung"
                           :isDisabled="isFormDisabled()"
                           v-model="model.anmerkung"
                           class="layout-wrap flex-gt-sm-100 flex-100"></anmerkung>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>
      </lx-expansion-panels>
    </div>
  </div>
</template>

<script>
import diagnose from '../shared/Diagnose'
import malignesMelanom from '../shared/ModulMalignesMelanom'
import modulProstata from '../shared/ModulProstata'
import modulMamma from '../shared/ModulMamma'
import modulKolo from '../shared/ModulKolo'
import leistungszustand from '../shared/Leistungszustand'
import histologie from '../shared/HistologieMulti'
import tnm from '../shared/TNM'
import weitereKlassifikationen from '../shared/WeitereKlassifikation'
import fruehereTumorerkrankung from '../shared/FruehereTumorerkrankung'
import fernmetastase from '../shared/Fernmetastase'
import modulAllgemein from '../shared/ModulAllgemein'
import anmerkung from '../shared/Anmerkung'
import melder from '../shared/Melder'
import genetischeVariante from '../shared/GenetischeVariante.vue'

import utils from '../../../common/utils'
import lodash from 'lodash'

export default {
name: 'Register',
  components: {
    diagnose,
    malignesMelanom,
    modulProstata,
    modulMamma,
    modulKolo,
    leistungszustand,
    histologie,
    tnm,
    fruehereTumorerkrankung,
    fernmetastase,
    weitereKlassifikationen,
    modulAllgemein,
    anmerkung,
    melder,
    genetischeVariante
  },
  mixins: [utils],
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    validationRef: {
      type: Object,
      default: () => ({})
    },
    modulesAreEmpty: {
      type: Object,
      default: () => ({})
    },
    // is used to mark headers of invalid modules after trying to complete form (function in utils)
    setIsCompletedIsTriggered: {
      type: Boolean,
      default: false
    },
    formId: {
      type: String
    },
    formStatus: {
      type: String
    },
    patientId: {
      type: String
    },
    additionalItemsList: {
      type: Array,
      default: () => ([])
    },
    multiFormsCount: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      model: {
        key: 'register'
      },
      panel: []
    }
  },
  created () {
    this.panel = lodash.clone(this.modulesAreEmpty.defaultPanel)
  },
  computed: {
    // set date of diagnosis as lead date for multiple modules
    leadDate () {
      return this.model.diagnose && this.model.diagnose.diagnosedatum ? this.model.diagnose.diagnosedatum : null
    },
    leadDiagnosisCode () {
      return this.model.diagnose && this.model.diagnose.primaertumor_icd_code ? this.model.diagnose.primaertumor_icd_code : null
    },
    isMedicalCommunity () {
      const user = this.authStore.getters.getAuthUserData && this.authStore.getters.getAuthUserData.user ? this.authStore.getters.getAuthUserData.user : {}
      return user.cancer_form_details && user.cancer_form_details.isMedicalCommunity
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
        }
      },
      immediate: true
    },
    'modulesAreEmpty.modules': {
      handler: function () {
        this.panel = lodash.clone(this.modulesAreEmpty.defaultPanel)

        const self = this
        Object.keys(this.modulesAreEmpty.modules).forEach(key => {
          // push index of filled modules in panel (selected modules are not opened via default)
          if (!self.modulesAreEmpty.modules[key].value && self.panel.indexOf(self.modulesAreEmpty.modules[key].index) < 0) {
            this.$nextTick(() => {
              self.panel.push(self.modulesAreEmpty.modules[key].index)
            })
          }
        })
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

